import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/ethereum/smart-contracts';

export const FETCH_SMART_CONTRACT_BY_NAME = defineApiActionTypes(
  `${prefix}/FETCH_SMART_CONTRACT_BY_NAME`
);



// WEBPACK FOOTER //
// ./src/store/features/ethereum/smart-contracts/action-types.js